import React from 'react';
import {
  Box, Button, Chip, LinearProgress, Typography,
} from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { useLocalizedMessage } from '../../../util/useLocalizedMessage';

export function TypedErrorAlert({ error, onRetry = null }) {
  const t = useLocalizedMessage();
  if (!error) return null;
  return (
    <Box mb={2} data-testid="merchandising-error">
      <Alert
        severity="error"
        action={onRetry ? (
          <Button color="inherit" size="small" onClick={onRetry}>
            {t('merchandising.action.retry')}
          </Button>
        ) : null}
      >
        <Typography variant="body2">{error.message || t('merchandising.error.generic')}</Typography>
        {error.requestId && (
          <Typography variant="caption" component="div">
            {t('merchandising.error.requestId', { requestId: error.requestId })}
          </Typography>
        )}
      </Alert>
    </Box>
  );
}

export function CapabilityNotice({ enabled, children }) {
  const t = useLocalizedMessage();
  if (enabled) return children;
  return (
    <Alert severity="info" data-testid="merchandising-capability-notice">
      {t('merchandising.capability.unavailable')}
    </Alert>
  );
}

export function IndexStateBadge({ value, loading = false }) {
  const t = useLocalizedMessage();
  if (loading && !value) return <LinearProgress aria-label={t('merchandising.index.loading')} />;
  if (!value) return null;
  const state = value.state || value.status || (value.dirty === true ? 'dirty' : 'clean');
  const color = state === 'clean' ? 'primary' : (state === 'failed' ? 'secondary' : 'default');
  return (
    <Chip
      size="small"
      color={color}
      data-testid="merchandising-index-state"
      label={t(`merchandising.index.${state}`)}
    />
  );
}
